import React, {Component} from "react";
import {Col, Row, Tooltip} from "antd";
import {CheckCircleTwoTone, FileImageOutlined} from "@ant-design/icons";

class CustomerDataView extends Component<any, any> {
    render() {
        return (
            <React.Fragment>
                <Row className={`pt-5`}>
                    <Col xs={24} xl={6} className={`col-grey-small-80`}> <i>Nomor Telpon:</i></Col>
                    <Col xs={24} xl={18}>
                        {this.props?.phoneNumber}
                        {this.props?.phoneNumberWaAvailable ? <Tooltip title="Whatsapp Aktif ">&nbsp;<CheckCircleTwoTone twoToneColor="#52c41a"/></Tooltip> : null}
                        &nbsp;
                        {this.props?.alternativePhoneNumber}
                    </Col>
                </Row>
                <Row className={`pt-5`}>
                    <Col xs={24} xl={6} className={`col-grey-small-80`}> <i>Nomor KTP:</i></Col>
                    <Col xs={24} xl={18}>{this.props?.idCard?.id_card_number} {this.props?.idCard?.id_card_image && <a target={'_blank'} rel="noreferrer" href={this.props?.idCard?.id_card_image}> &nbsp; <FileImageOutlined/> Lihat Image </a>}</Col>
                </Row>
                <Row className={`pt-5`}>
                    <Col xs={24} xl={6} className={`col-grey-small-80`}> <i>Nama:</i></Col>
                    <Col xs={24} xl={18}>{this.props?.idCard?.full_name?.toUpperCase()}</Col>
                </Row>
                <Row className={`pt-5`}>
                    <Col xs={24} xl={6} className={`col-grey-small-80`}> <i>Tempat Tanggal Lahir:</i></Col>
                    <Col xs={24} xl={18}>{this.props?.idCard?.birth_place} {this.props?.idCard?.birth_date?.substring(0, 10)} &nbsp;</Col>
                </Row>
                <Row className={`pt-5`}>
                    <Col xs={24} xl={6} className={`col-grey-small-80`}> <i>Alamat:</i></Col>
                    <Col xs={24} xl={18}>{this.props?.address?.full_address}</Col>
                </Row>
                <Row className={`pt-5`}>
                    <Col xs={24} xl={6} className={`col-grey-small-80`}> <i></i></Col>
                    <Col xs={24} xl={18}>{this.props?.address?.province_name?.toUpperCase()}, {this.props?.address?.city_name?.toUpperCase()}, {this.props?.address?.district_name?.toUpperCase()}, {this.props?.address?.sub_district_name?.toUpperCase()}, {this.props?.address?.zip_code}</Col>
                </Row>
                <Row className={`pt-5`}>
                    <Col xs={24} xl={6} className={`col-grey-small-80`}> <i>Jenis Kelamin:</i></Col>
                    <Col xs={24} xl={18}>{this.props?.idCard?.sex} &nbsp;</Col>
                </Row>
                <Row className={`pt-5`}>
                    <Col xs={24} xl={6} className={`col-grey-small-80`}> <i>Agama:</i></Col>
                    <Col xs={24} xl={18}>{this.props?.idCard?.religion} &nbsp;</Col>
                </Row>
                <Row className={`pt-5`}>
                    <Col xs={24} xl={6} className={`col-grey-small-80`}> <i>Status Perkawinan:</i></Col>
                    <Col xs={24} xl={18}>{this.props?.idCard?.marital_status} &nbsp;</Col>
                </Row>
                <Row className={`pt-5`}>
                    <Col xs={24} xl={6} className={`col-grey-small-80`}> <i>Pekerjaan:</i></Col>
                    <Col xs={24} xl={18}>{this.props?.idCard?.occupation} &nbsp;</Col>
                </Row>
            </React.Fragment>
        );
    }
}

export default CustomerDataView;